<template>
  <div class="nominations" id="reportVEAwards">
    <ul class="list-group mb-4">
      <li v-if="nominations.length > 0" v-for="(nomination, index) in nominations" v-bind:key="nomination.id" class="list-group-item mb-4">
        <div v-if="index < 100">
        <div class="d-sm-flex pt-2">
          <figure>
            <img  v-if="nomination.isteamaward && nomination.isteamaward[0] != 'true'" class="border border-secondary rounded" src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/06/generic-profile.png" width="120" height="120">
            <img  v-else class="border border-secondary rounded" src="https://thinktankapi.multichoice.com/wp-content/uploads/2018/10/team-profile.png" width="120" height="120">
            <figcaption class="text-center small pt-1 font-weight-bold" v-if="nomination.isteamaward && nomination.isteamaward[0] != 'true'">
              <router-link :to="'/thinktank-user/' + nomination.nominee_slug[0]" target="_blank">{{nomination.nominee_name[0]}}</router-link><br>
              <!--<span class="text-secondary">insertCompany</span>-->
            </figcaption>
          </figure>
          <div class="pl-sm-4">
            <!--img class="float-right" :src="'static/' + nomination.author_country + '.svg'" width="50" height="33"-->
            <h4 v-html="nomination.title && nomination.title.rendered"></h4>
            <ul class="list-inline">
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-user fa-fw"></i>
                  Nomination by:
                  <router-link :to="'/thinktank-user/' + nomination._embedded.author[0].slug" target="_blank">{{nomination._embedded.author[0].name}}</router-link>
                </small>
              </li>
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-address-card fa-fw"></i>
                  Staff no. {{nomination.nominator_details[0][0]['employee-number']}}
                </small>
              </li>
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-building fa-fw"></i>
                  {{nomination.nominator_details[0][0]['employee-company']}}
                </small>
              </li>
              <li class="list-inline-item text-black-50">
                <small class="font-weight-bold">
                  <i class="fas fa-clock fa-fw"></i>
                  {{nomination.date.substring(0, 10)}}
                </small>
              </li>
            </ul>
            <hr>
            <div class="mb-2" v-if="nomination.isteamaward && nomination.isteamaward.length === 0">
              <strong>Nominee company:</strong><br>
              {{nomination.nominee_company[0]}}
            </div>
            <div class="mb-2">
              <strong>Option1 : </strong>  {{nomination.MCGEOYOption1[0].email}} <br>
              <strong>Option2 : </strong>  {{nomination.MCGEOYOption2[0].email}} <br>
              <strong>Option3 : </strong>  {{nomination.MCGEOYOption3[0].email}} <br>          
            </div>            
          </div>
        </div>
      </div>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: [
    'nominations'
  ],
  data () {
    return {
      nominationsWithCountry: []
    }
  },
  created () {
    this.nominationsWithCountry = this.nominations
  }
}
</script>


// WEBPACK FOOTER //
// src/components/NominationMCGEmployeeReportEntries.vue